/// <reference path="wpt.ts" />
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/// <reference path="widgets/widgetsActionPalette.ts" />
/// <reference path="widgets/widgetsBasicQueue.ts" />
/// <reference path="widgets/widgetsBasicSearch.ts" />
/// <reference path="widgets/widgetsBasicViewer.ts" />
/// <reference path="widgets/widgetsChart.ts" />
/// <reference path="widgets/widgetsCreateAccount.ts" />
/// <reference path="widgets/widgetsCrossReferences.ts" />
/// <reference path="widgets/widgetsDocTypeChooser.ts" />
/// <reference path="widgets/widgetsDocumentInfo.ts" />
/// <reference path="widgets/widgetsDocumentKeywords.ts" />
/// <reference path="widgets/widgetsDocumentModifier.ts" />
/// <reference path="widgets/widgetsDocumentPackager.ts" />
/// <reference path="widgets/widgetsDummy.ts" />
/// <reference path="widgets/widgetsFAQ.ts" />
/// <reference path="widgets/widgetsFavouriteDocuments.ts" />
/// <reference path="widgets/widgetsFolderTree.ts" />
/// <reference path="widgets/widgetsFormList.ts" />
/// <reference path="widgets/widgetsHtmlContent.ts" />
/// <reference path="widgets/widgetsInstructions.ts" />
/// <reference path="widgets/widgetsLogin.ts" />
/// <reference path="widgets/widgetsLoginExtra.ts" />
/// <reference path="widgets/widgetsMultiDocUpload.ts" />
/// <reference path="widgets/widgetsMultiSearch.ts" />
/// <reference path="widgets/widgetsNavigator.ts" />
/// <reference path="widgets/widgetsNotePanel.ts" />
/// <reference path="widgets/widgetsRecentDocuments.ts" />
/// <reference path="widgets/widgetsRequiredDocuments.ts" />
/// <reference path="widgets/widgetsSavedSearches.ts" />
/// <reference path="widgets/widgetsSearchBar.ts" />
/// <reference path="widgets/widgetsSearchKeywords.ts" />
/// <reference path="widgets/widgetsSecurityKeywords.ts" />
/// <reference path="widgets/widgetsTableSearch.ts" />
/// <reference path="widgets/widgetsTimer.ts" />
/// <reference path="widgets/widgetsUploadFiles.ts" />
/// <reference path="widgets/widgetsUploadKeywords.ts" />
/// <reference path="widgets/widgetsUserGroupList.ts" />
/// <reference path="widgets/widgetsUserList.ts" />
/// <reference path="widgets/widgetsViewForms.ts" />
/// <reference path="widgets/widgetsWorkflowQueues.ts" />
/// <reference path="widgets/widgetsWorkViewClassList.ts" />
/// <reference path="widgets/widgetsWorkViewFilterList.ts" />
/// <reference path="widgets/widgetsWorkViewFilterResult.ts" />
/// <reference path="widgets/widgetsWorkViewObject.ts" />
var WPTNamespace;
(function (WPTNamespace) {
    /**
     * Namespace for widget management logic.
     */
    let Widgets;
    (function (Widgets) {
        Widgets.WIDGET_SELECTED_CLASS = 'selected';
        Widgets.WIDGET_SIZE_TARGET_CLASS = 'widget__size-target';
        const LOG_CATEGORY = "WPT.Widgets";
        const DEFAULT_COLLAPSE_STATE = "Responsive";
        const HEIGHT_CLASS = 'widget__size';
        const HEIGHT_CLASS_FULL = 'widget__size--full';
        const HEIGHT_CLASS_HALF = 'widget__size--half';
        const HEIGHT_CLASS_QUARTER = 'widget__size--quarter';
        const NO_BORDER_CLASS = 'widget--no-border';
        const NO_HEADER_CLASS = 'widget__header--no-header';
        const WIDGET_SIZE_SELECTOR = '.' + Widgets.WIDGET_SIZE_TARGET_CLASS;
        const WIDGET_PANEL_SELECTOR = '.widget__collapse-target';
        const WIDGET_HEADING_SELECTOR = '.widget__header';
        const WIDGET_CONTAINER_SELECTOR = 'div.widget';
        const WIDGET_TITLE_CLASS = 'widget__header-titleText';
        const WIDGET_TITLEICON_CLASS = 'widget__header-titleIcon';
        const DEFAULT_ICON_COLLAPSED = "wpt-font wpt-font-icon_Down";
        const DEFAULT_ICON_EXPANDED = "wpt-font wpt-font-icon_Up";
        /*
        const DEFAULT_ICON_COLLAPSED = "wpt-font wpt-font-expand";
        const DEFAULT_ICON_EXPANDED = "wpt-font wpt-font-compress";
        */
        const STANDARD_WIDGETS = [
            {
                Name: "ActionPalette",
                Class: "WPTNamespace.Widgets.ActionPaletteWidgetTypeClass"
            },
            {
                Name: "BasicQueue",
                Class: "WPTNamespace.Widgets.BasicQueueWidgetTypeClass"
            },
            {
                Name: "BasicSearch",
                Class: "WPTNamespace.Widgets.BasicSearchWidgetTypeClass"
            },
            {
                Name: "BasicViewer",
                Class: "WPTNamespace.Widgets.BasicViewerWidgetTypeClass"
            },
            {
                Name: "Chart",
                Class: "WPTNamespace.Widgets.ChartWidgetTypeClass"
            },
            {
                Name: "CreateAccount",
                Class: "WPTNamespace.Widgets.CreateAccountWidgetTypeClass"
            },
            {
                Name: "CrossReferences",
                Class: "WPTNamespace.Widgets.CrossReferencesWidgetTypeClass"
            },
            {
                Name: "DocTypeChooser",
                Class: "WPTNamespace.Widgets.DocTypeChooserWidgetTypeClass"
            },
            {
                Name: "DocumentInfo",
                Class: "WPTNamespace.Widgets.DocumentInfoWidgetTypeClass"
            },
            {
                Name: "DocumentKeywords",
                Class: "WPTNamespace.Widgets.DocumentKeywordsWidgetTypeClass"
            },
            {
                Name: "DocumentModifier",
                Class: "WPTNamespace.Widgets.DocumentModifierWidgetTypeClass"
            },
            {
                Name: "DocumentPackager",
                Class: "WPTNamespace.Widgets.DocumentPackagerWidgetTypeClass"
            },
            {
                Name: "Dummy",
                Class: "WPTNamespace.Widgets.DummyWidgetTypeClass"
            },
            {
                Name: "Envelopes",
                Class: "WPTNamespace.Widgets.EnvelopesWidgetTypeClass"
            },
            {
                Name: "FAQ",
                Class: "WPTNamespace.Widgets.FAQWidgetTypeClass"
            },
            {
                Name: "FavouriteDocuments",
                Class: "WPTNamespace.Widgets.FavouriteDocumentsWidgetTypeClass"
            },
            {
                Name: "FolderTree",
                Class: "WPTNamespace.Widgets.FolderTreeWidgetTypeClass"
            },
            {
                Name: "FormList",
                Class: "WPTNamespace.Widgets.FormListWidgetTypeClass"
            },
            {
                Name: "HtmlContent",
                Class: "WPTNamespace.Widgets.HtmlContentWidgetTypeClass"
            },
            {
                Name: "Instructions",
                Class: "WPTNamespace.Widgets.InstructionsWidgetTypeClass"
            },
            {
                Name: "Login",
                Class: "WPTNamespace.Widgets.LoginWidgetTypeClass"
            },
            {
                Name: "LoginExtra",
                Class: "WPTNamespace.Widgets.LoginExtraWidgetTypeClass"
            },
            {
                Name: "MultiDocUpload",
                Class: "WPTNamespace.Widgets.MultiDocUploadWidgetTypeClass"
            },
            {
                Name: "MultiSearch",
                Class: "WPTNamespace.Widgets.MultiSearchWidgetTypeClass"
            },
            {
                Name: "Navigator",
                Class: "WPTNamespace.Widgets.NavigatorWidgetTypeClass"
            },
            {
                Name: "NotePanel",
                Class: "WPTNamespace.Widgets.NotePanelWidgetTypeClass"
            },
            {
                Name: "Questions",
                Class: "WPTNamespace.Widgets.QuestionsWidgetTypeClass"
            },
            {
                Name: "RecentDocuments",
                Class: "WPTNamespace.Widgets.RecentDocumentsWidgetTypeClass"
            },
            {
                Name: "RequiredDocuments",
                Class: "WPTNamespace.Widgets.RequiredDocumentsWidgetTypeClass"
            },
            {
                Name: "SavedSearches",
                Class: "WPTNamespace.Widgets.SavedSearchesWidgetTypeClass"
            },
            {
                Name: "SearchBar",
                Class: "WPTNamespace.Widgets.SearchBarWidgetTypeClass"
            },
            {
                Name: "SearchKeywords",
                Class: "WPTNamespace.Widgets.SearchKeywordsWidgetTypeClass"
            },
            {
                Name: "SecurityKeywords",
                Class: "WPTNamespace.Widgets.SecurityKeywordsWidgetTypeClass"
            },
            {
                Name: "TableSearch",
                Class: "WPTNamespace.Widgets.TableSearchWidgetTypeClass"
            },
            {
                Name: "Timer",
                Class: "WPTNamespace.Widgets.TimerWidgetTypeClass"
            },
            {
                Name: "UploadDocList",
                Class: "WPTNamespace.Widgets.UploadDocListWidgetTypeClass"
            },
            {
                Name: "UploadFiles",
                Class: "WPTNamespace.Widgets.UploadFilesWidgetTypeClass"
            },
            {
                Name: "UploadKeywords",
                Class: "WPTNamespace.Widgets.UploadKeywordsWidgetTypeClass"
            },
            {
                Name: "UserGroupList",
                Class: "WPTNamespace.Widgets.UserGroupListWidgetTypeClass"
            },
            {
                Name: "UserList",
                Class: "WPTNamespace.Widgets.UserListWidgetTypeClass"
            },
            {
                Name: "ViewForms",
                Class: "WPTNamespace.Widgets.ViewFormsWidgetTypeClass"
            },
            {
                Name: "WorkflowQueues",
                Class: "WPTNamespace.Widgets.WorkflowQueuesWidgetTypeClass"
            },
            {
                Name: "WorkViewClassList",
                Class: "WPTNamespace.Widgets.WorkViewClassListWidgetTypeClass"
            },
            {
                Name: "WorkViewFilterList",
                Class: "WPTNamespace.Widgets.WorkViewFilterListWidgetTypeClass"
            },
            {
                Name: "WorkViewFilterResult",
                Class: "WPTNamespace.Widgets.WorkViewFilterResultWidgetTypeClass"
            },
            {
                Name: "WorkViewObject",
                Class: "WPTNamespace.Widgets.WorkViewObjectWidgetTypeClass"
            }
        ];
        class WidgetTypeBaseClass {
            constructor(core, widgets, widgetName, config, layout, readyCallback = null) {
                this.Instances = null;
                this._core = null;
                this._log = null;
                this._widgets = null;
                this._name = null;
                this._config = null;
                this._onlySingleInstanceAllowed = false;
                this._allowedOnLogon = false;
                this._originatingLayout = null;
                this._readyCallback = null;
                this._readyCounter = 0;
                this.createInstances = () => {
                    this._log.info("WidgetTypeBaseClass.createInstances()");
                    this.Instances = [];
                    this._readyCounter = 0;
                    if (this._config.hasOwnProperty('Instance')) {
                        let instanceLength = this._config.Instance.length;
                        for (let i = 0; i < instanceLength; i++) {
                            let instanceConfig = this._config.Instance[i];
                            if (!instanceConfig.hasOwnProperty('Disabled') || !instanceConfig.Disabled) {
                                if (this._log.isTraceEnabled()) {
                                    this._log.trace("instance " + (i + 1) + " is active");
                                }
                                if (!this._allowedOnLogon && this._originatingLayout === WPTNamespace.Navigation.LOGON_VIEW_NAME) {
                                    console.warn("failed to create widget '" + this._name + "' - not allowed on 'Logon' page");
                                    break;
                                }
                                let widgetInstance = this.createInstance(instanceConfig);
                                this.Instances[widgetInstance.getId()] = widgetInstance;
                                this.Instances.push(widgetInstance);
                                if (this._onlySingleInstanceAllowed) {
                                    console.warn("failed to create widget instance for '" + this._name + "' - only single instance allowed");
                                    break;
                                }
                            }
                            else {
                                if (this._log.isTraceEnabled()) {
                                    this._log.trace("instance '" + (i + 1) + "' is not active");
                                }
                            }
                        }
                    }
                    else {
                        console.warn("no 'Instance' property configured in application");
                    }
                };
                this.instanceReady = (instanceHandle) => {
                    this._log.info("WidgetTypeBaseClass.instanceReady()");
                    if (this._log.isTraceEnabled()) {
                        this._log.trace("instance '" + instanceHandle + "' is ready");
                    }
                    this._readyCounter++;
                    if (this._readyCounter >= this.Instances.length) {
                        if (this._log.isTraceEnabled()) {
                            this._log.trace("all instances are ready...");
                        }
                        if (this._readyCallback != null) {
                            this._readyCallback(this._name);
                        }
                    }
                };
                this.getName = () => {
                    this._log.info("WidgetTypeBaseClass.getName()");
                    return this._name;
                };
                this._presentInstances = () => {
                    this._log.info("WidgetTypeBaseClass._presentInstances()");
                    if (this.Instances != null && this.Instances.length > 0) {
                        if (this._log.isTraceEnabled()) {
                            this._log.trace("presenting all instances...");
                        }
                        this.Instances.forEach(function (instance) {
                            instance.presentInstance();
                        });
                    }
                };
                this._core = core;
                this._log = this._core.Logging.getLogger(LOG_CATEGORY);
                this._log.info("WidgetTypeBaseClass::constructor");
                this._widgets = widgets;
                this._name = widgetName;
                this._config = config;
                this._originatingLayout = layout;
                this._readyCallback = readyCallback;
            }
            createInstance(config) {
                throw new TypeError("Must override method createInstance(config: WidgetInstanceConfig): WidgetInstanceBaseClass");
            }
        }
        Widgets.WidgetTypeBaseClass = WidgetTypeBaseClass;
        class WidgetInstanceBaseClass {
            constructor(core, type, widgets, config, layout) {
                this._core = null;
                this._log = null;
                this._type = null;
                this._widgets = null;
                this._config = null;
                this._id = null;
                this._originatingLayout = null;
                this._currentLayout = null;
                this._capabilites = [];
                // Currently, only visible widgets are even created, so this should be safe
                this._container = null;
                this._errorMessages = null;
                this._errorBanner = null;
                this._errorBannerCount = null;
                this.getId = () => {
                    this._log.info("WidgetInstanceBaseClass.getId()");
                    return this._id;
                };
                this.getOriginatingLayout = () => {
                    this._log.info("WidgetInstanceBaseClass.getOriginatingLayout()");
                    return this._originatingLayout;
                };
                // We should be able to create a handle from the layout and placeholder, as long as everyone has played by
                // the rules and not created multiple placeholders with the same name on a given layout!
                // Format: <Layout Name>.<placeholder id>
                this.getHandle = () => {
                    this._log.info("WidgetInstanceBaseClass.getHandle()");
                    return `${this._originatingLayout}.${this._id}`;
                };
                this.addError = (errorMsg) => {
                    this._log.info("WidgetInstanceBaseClass.addError()");
                    this._errorMessages.push(errorMsg);
                    if (this._errorBanner) {
                        this._errorBannerCount.innerHTML = "" + this._errorMessages.length;
                        this._core.Functions.showElement(this._errorBanner);
                    }
                };
                this._clearErrors = () => {
                    this._log.info("WidgetInstanceBaseClass._clearErrors()");
                    this._errorMessages = [];
                    if (this._errorBanner) {
                        this._errorBannerCount.innerHTML = "" + this._errorMessages.length;
                        this._core.Functions.hideElement(this._errorBanner);
                    }
                };
                this._closeErrorBanner = (event) => {
                    this._log.info("WidgetInstanceBaseClass._closeErrorBanner()");
                    // not display the modal in this case
                    event.stopPropagation();
                    this._core.Functions.hideElement(this._errorBanner);
                };
                this._displayErrorModal = (event) => {
                    this._log.info("WidgetInstanceBaseClass._displayErrorModal()");
                    let errorMsg = this._core.Locale.getTranslation("STR_WPT_ERRORS_OCCURED_MSG");
                    errorMsg += "<ul class='wpt-bullet-list'>";
                    let length = this._errorMessages.length;
                    for (let i = 0; i < length; i++) {
                        let msg = this._errorMessages[i];
                        errorMsg += "<li>" + msg + "</li>";
                    }
                    errorMsg += "</ul>";
                    this._core.Helper.presentWarningModal(errorMsg);
                };
                this._prepareErrorBanner = () => {
                    this._log.info("WidgetInstanceBaseClass._prepareErrorBanner()");
                    this._errorBanner = this._container.querySelector(".widget__error-panel");
                    if (this._errorBanner) {
                        if (this._log.isTraceEnabled()) {
                            this._log.trace("found error banner");
                        }
                        let errorContent = document.createElement("span");
                        this._errorBanner.appendChild(errorContent);
                        let closeIcon = document.createElement("span");
                        errorContent.appendChild(closeIcon);
                        closeIcon.classList.add("widget__error-panel-close", "wpt-font", "wpt-font-icon_Close", "pull-right");
                        closeIcon.addEventListener("click", this._closeErrorBanner);
                        let errorIcon = document.createElement("span");
                        errorContent.appendChild(errorIcon);
                        errorIcon.classList.add("widget__error-panel-icon", "wpt-font", "wpt-font-error");
                        this._errorBannerCount = document.createElement("span");
                        errorContent.appendChild(this._errorBannerCount);
                        this._errorBannerCount.classList.add("widget__error-panel-badge");
                        this._errorBannerCount.innerHTML = "" + this._errorMessages.length;
                        let errorInfoSpan = document.createElement('span');
                        errorContent.appendChild(errorInfoSpan);
                        errorInfoSpan.classList.add('widget__error-panel-text');
                        this._core.Helper.setElementTranslation(errorInfoSpan, "STR_WPT_ERRORS_OCCURED");
                        this._errorBanner.addEventListener("click", this._displayErrorModal);
                        if (this._errorMessages.length > 0) {
                            this._core.Functions.showElement(this._errorBanner);
                        }
                        else {
                            this._core.Functions.hideElement(this._errorBanner);
                        }
                    }
                };
                this._activationSourceValid = (context) => {
                    this._log.info("WidgetInstanceBaseClass._activationSourceValid()");
                    // Always respond to null
                    if (context.ActivatingWidget == null)
                        return true;
                    // Never respond to self
                    if (context.ActivatingWidget == this)
                        return false;
                    // Apply filters if any are configured
                    if (this._config.hasOwnProperty('ActivationWidgetFilters') && (this._config.ActivationWidgetFilters != null)) {
                        if (this._log.isTraceEnabled()) {
                            this._log.trace("looking at activation filters: " + JSON.stringify(this._config.ActivationWidgetFilters));
                        }
                        // First look for a specific rule - if there is none see if there is a general rule
                        let filterSpec = this._config.ActivationWidgetFilters.find(fl => fl.MessageTypes.indexOf(context.ActivationType) > -1);
                        if (!filterSpec)
                            filterSpec = this._config.ActivationWidgetFilters.find(fl => fl.MessageTypes.indexOf('*') > -1);
                        if (filterSpec) {
                            // Accept takes precedence over exclude
                            if (filterSpec.hasOwnProperty('AcceptFrom') && (filterSpec.AcceptFrom != null)) {
                                if (filterSpec.AcceptFrom.indexOf(context.ActivatingWidget.Handle) > -1)
                                    return true;
                                else
                                    return false;
                            }
                            else if (filterSpec.hasOwnProperty('ExcludeFrom') && (filterSpec.ExcludeFrom != null)) {
                                if (filterSpec.ExcludeFrom.indexOf(context.ActivatingWidget.Handle) > -1)
                                    return false;
                                else
                                    return true;
                            }
                        }
                    }
                    // Accept by default
                    return true;
                };
                this._core = core;
                this._log = this._core.Logging.getLogger(LOG_CATEGORY);
                this._log.info("WidgetInstanceBaseClass::constructor");
                this._type = type;
                this._widgets = widgets;
                this._config = config;
                this._originatingLayout = layout;
                this._currentLayout = layout;
                this._errorMessages = [];
                // If we don't have a placeholder, we have a problem.
                if (config.hasOwnProperty('PlaceHolder') && config.PlaceHolder.length > 0) {
                    this._id = config.PlaceHolder;
                    this._container = document.querySelector(config.PlaceHolder);
                    if (!this._container) {
                        console.error(type.getName() + " widget instance container '" + this._id + "' not found");
                    }
                }
                else {
                    console.error(type.getName() + " widget instance is missing configuration setting 'PlaceHolder'");
                }
            }
            get Id() {
                this._log.info("WidgetInstanceBaseClass.Id()");
                return this._id;
            }
            get Container() {
                this._log.info("WidgetInstanceBaseClass.Container()");
                return this._container;
            }
            get TypeName() {
                this._log.info("WidgetInstanceBaseClass.TypeName()");
                return this._type.getName();
            }
            get Capabilities() {
                this._log.info("WidgetInstanceBaseClass.Capabilities()");
                return this._capabilites;
            }
            get Handle() {
                this._log.info("WidgetInstanceBaseClass.Handle()");
                return `${this._originatingLayout}.${this._id}`;
            }
            // Allows widget to react to changes in circumstance. Reserved options are "Home", "[[-CACHE-]]", "[[-FREEZER-]]"
            // Set up so that children can call super.
            setCurrentLayout(layout) {
                this._log.info("WidgetInstanceBaseClass.setCurrentLayout()");
                this._currentLayout = layout;
            }
            get CurrentLayout() {
                this._log.info("WidgetInstanceBaseClass.CurrentLayout()");
                return this._currentLayout;
            }
            presentInstance() {
                throw new TypeError("Must override method presentInstance(): void");
            }
            // Causes the widget to remove itself from the current container and redraw into another
            reparentInstance(newLocation, newLayout) {
                this._log.info("WidgetInstanceBaseClass.reparentInstance()");
                // Can't reparent if we don't have a parent
                if (this._log.isTraceEnabled()) {
                    this._log.trace(`new location: ${newLocation.id}`);
                }
                if (this._container == null)
                    return;
                while (this._container.childNodes.length) {
                    newLocation.appendChild(this._container.firstChild);
                }
                this._container = newLocation;
                if (newLayout)
                    this.setCurrentLayout(newLayout);
            }
            // Allows for self-aware managemend of change contexts from layout.activate. 
            activate(context) {
                this._log.info("WidgetInstanceBaseClass.activate()");
                return;
            }
            returnedToHomepage() {
                this._log.info("WidgetInstanceBaseClass.returnedToHomepage()");
                return;
            }
            // Used to support cross-widget structures (e.g. upload using external keyword panel widget)
            // By default we want to refuse any connections, as only specific widgets will be able to use them
            requestDirectConnection(service, requestor) {
                this._log.info("WidgetInstanceBaseClass.requestDirectConnection()");
                return false;
            }
        }
        Widgets.WidgetInstanceBaseClass = WidgetInstanceBaseClass;
        /**
         * Class handling temporary storage of widgets whilst changing between layouts.
         * Provides a (hidden!) space to store active widget instances which includes a DIV in the DOM so that
         * all the innerHTML for the widget instance is preserved.
         */
        class WidgetCacheEntry {
        }
        class WidgetCache {
            constructor(core) {
                this._log = null;
                this._container = null;
                // Data checks
                this.isCached = (handle) => {
                    this._log.info("WidgetCache.isCached()");
                    return (handle in this._cache);
                };
                this.isFrozen = (handle) => {
                    this._log.info("WidgetCache.isFrozen()");
                    return (handle in this._freezer);
                };
                // Normal use
                this.cacheInstance = (instance) => {
                    this._log.info("WidgetCache.cacheInstance()");
                    this._storeInstance(instance, false);
                };
                // Additional facility for non-volatile storage, not cleared when cache emptied
                this.freezeInstance = (instance) => {
                    this._log.info("WidgetCache.freezeInstance()");
                    this._storeInstance(instance, true);
                };
                this._storeInstance = (instance, deepFreeze) => {
                    this._log.info("WidgetCache._storeInstance()");
                    if (this._log.isTraceEnabled()) {
                        this._log.trace(`deepFreeze = ${deepFreeze}`);
                    }
                    if ((!instance) || (!instance.Container))
                        return;
                    if (this._log.isTraceEnabled()) {
                        this._log.trace(`storing ${instance.Handle}`);
                    }
                    let store = deepFreeze ? this._freezer : this._cache;
                    let layout = deepFreeze ? "[[-FREEZER-]]" : "[[-CACHE-]]";
                    // Don't cache something twice - it will overwrite anyway
                    if (instance.Handle in store)
                        return;
                    // Setup
                    this._instanceCounter++;
                    let divId = `WidgetHoldingCache_${this._instanceCounter.toString()}`;
                    let cacheEntry = new WidgetCacheEntry();
                    cacheEntry.DivSelector = `#${divId}`;
                    cacheEntry.WidgetInstance = instance;
                    cacheEntry.From = instance.Container.id;
                    // Create our holding DIV and store it
                    cacheEntry.Container = document.createElement('div');
                    cacheEntry.Container.id = divId;
                    this._container.appendChild(cacheEntry.Container);
                    // Reparent instance
                    instance.reparentInstance(cacheEntry.Container, layout);
                    // Store the result
                    store[instance.Handle] = cacheEntry;
                };
                // Functions as a delete as well, but forces a reparent to extract the widget instance intact
                this.popInstance = (handle, target, layout) => {
                    this._log.info("WidgetCache.popInstance()");
                    return this._extractInstance(handle, target, layout, false);
                };
                this.defrostInstance = (handle, target, layout) => {
                    this._log.info("WidgetCache.defrostInstance()");
                    return this._extractInstance(handle, target, layout, true);
                };
                this._extractInstance = (handle, target, layout, deepFreeze) => {
                    this._log.info("WidgetCache._extractInstance()");
                    if (this._log.isTraceEnabled()) {
                        this._log.trace(`handle: ${handle}`);
                    }
                    let store = deepFreeze ? this._freezer : this._cache;
                    if ((target != null) && (handle in store)) {
                        let tempInstance = store[handle].WidgetInstance;
                        tempInstance.reparentInstance(target, layout);
                        this._killInstance(handle, deepFreeze);
                        return tempInstance;
                    }
                    else
                        throw TypeError("WidgetCache::popInstance requires valid handle and target DIV");
                };
                // Deletes without popping
                this.deleteCachedInstance = (handle) => {
                    this._log.info("WidgetCache.deleteCachedInstance()");
                    this._killInstance(handle, false);
                };
                this.deleteFrozenInstance = (handle) => {
                    this._log.info("WidgetCache.deleteFrozenInstance()");
                    this._killInstance(handle, true);
                };
                this._killInstance = (handle, deepFreeze) => {
                    this._log.info("WidgetCache._killInstance()");
                    if (this._log.isTraceEnabled()) {
                        this._log.trace(`handle: ${handle}`);
                    }
                    let store = deepFreeze ? this._freezer : this._cache;
                    if (handle in store) {
                        let divToKill = this._container.querySelector(store[handle].DivSelector);
                        this._container.removeChild(divToKill);
                        delete store[handle];
                    }
                };
                // Cache needs to be flushed after context changes
                // By default we return any remaining widget instances from the home layout back
                // before flushing otherwise they will get lost (or their HTML will at least)
                this.flushCache = (returnHomeInstances = true) => {
                    this._log.info("WidgetCache.flushCache()");
                    if (this._log.isTraceEnabled()) {
                        this._log.trace(`return home instances: ${returnHomeInstances}`);
                    }
                    let keys = Object.keys(this._cache);
                    keys.forEach(key => {
                        if (returnHomeInstances && (this._cache[key].WidgetInstance.getOriginatingLayout() == WPTNamespace.Navigation.HOME_VIEW_NAME)) {
                            let target = this._core.Navigation.Home.HomeView.querySelector(this._cache[key].WidgetInstance.getId());
                            this.popInstance(key, target, WPTNamespace.Navigation.HOME_VIEW_NAME);
                        }
                        else {
                            this.deleteCachedInstance(key);
                        }
                    });
                };
                // Used on logoff or application exit to remove any lasting items
                this.emptyFreezer = () => {
                    this._log.info("WidgetCache.emptyFreezer()");
                    let keys = Object.keys(this._freezer);
                    keys.forEach(key => {
                        this.deleteFrozenInstance(key);
                    });
                };
                this._core = core;
                this._log = this._core.Logging.getLogger(LOG_CATEGORY);
                this._log.info("WidgetCache::constructor");
                this._instanceCounter = 0;
                this._cache = {};
                this._freezer = {};
                this._container = document.querySelector("#WidgetHoldingStack");
                if (this._container == null) {
                    throw Error("DIV element '#WidgetHoldingStack' not defined in gateway HTML");
                }
            }
        }
        Widgets.WidgetCache = WidgetCache;
        /**
         * Class holding widget management logic. Depends on WPT "modules": Loader, Locale, Config, Navigation, Helper.
         */
        class WidgetManager {
            constructor(core) {
                // Note that these arrays are only populated for "Home" layout widgets
                this.StandardTypes = null;
                this.StandardInstances = null;
                this.CustomTypes = null;
                this.CustomInstances = null;
                this.Cache = null;
                this._core = null;
                this._log = null;
                this._useWidgetIcon = null;
                this._iconCollapsed = null;
                this._iconExpanded = null;
                this.displayHomepageWidgets = () => {
                    this._log.info("WidgetManager.displayHomepageWidgets()");
                    this.clearHomepageWidgets();
                    this._displayStandardWidgets();
                    this._displayCustomWidgets();
                };
                this.clearHomepageWidgets = () => {
                    this._log.info("WidgetManager.clearHomepageWidgets()");
                    this.StandardTypes = [];
                    this.StandardInstances = [];
                    this.CustomTypes = [];
                    this.CustomInstances = [];
                };
                this.returnedToHomepage = () => {
                    this._log.info("WidgetManager.returnedToHomepage()");
                    this.StandardInstances.forEach(widget => widget.returnedToHomepage());
                    this.CustomInstances.forEach(widget => widget.returnedToHomepage());
                };
                this.setTitle = (config, headerElement, defaultString = null) => {
                    this._log.info("WidgetManager.setTitle()");
                    if (config.hasOwnProperty('Title') && config.Title != null && config.Title.length > 0) {
                        this._setWidgetTitle(headerElement, config.Title);
                    }
                    else {
                        if (defaultString)
                            this._setWidgetTitle(headerElement, defaultString);
                        else
                            this._setWidgetTitle(headerElement, null);
                    }
                };
                this.setCollapseState = (config, placeholder) => {
                    this._log.info("WidgetManager.setCollapseState()");
                    let collapseState = DEFAULT_COLLAPSE_STATE;
                    let selector = placeholder + " " + WIDGET_PANEL_SELECTOR;
                    let jqElement = $(selector);
                    let containerSelector = placeholder + " " + WIDGET_CONTAINER_SELECTOR;
                    let containerElement = document.querySelector(containerSelector);
                    if (config.hasOwnProperty('CollapseState')) {
                        collapseState = config.CollapseState;
                        if (this._log.isTraceEnabled()) {
                            this._log.trace("using collapse state from config");
                        }
                    }
                    if (this._log.isTraceEnabled()) {
                        this._log.trace("using collapse state: " + collapseState);
                    }
                    switch (collapseState) {
                        case "Stealth":
                            this._expandWidget(containerElement, jqElement);
                            this._core.Functions.hideElement(containerElement);
                            break;
                        case "Show":
                            this._expandWidget(containerElement, jqElement);
                            break;
                        case "Hide":
                            this._collapseWidget(containerElement, jqElement);
                            break;
                        case "Responsive":
                        default:
                            if (this._core.Helper.isSmallDevice()) {
                                this._collapseWidget(containerElement, jqElement);
                            }
                            else {
                                this._expandWidget(containerElement, jqElement);
                            }
                            break;
                    }
                };
                this.addCollapseEventListener = (instance) => {
                    this._log.info("WidgetManager.addCollapseEventListener()");
                    let collapseElement = instance.Container.querySelector('.widget__collapse-activator');
                    if (collapseElement) {
                        let collapsePanel = $(`#${instance.Container.id} ${WIDGET_PANEL_SELECTOR}`);
                        if (collapsePanel) {
                            collapseElement.addEventListener('click', this._toggleWidgetCollapseState.bind(this, instance, collapsePanel));
                        }
                    }
                };
                this.setSuppressBorder = (config, containerElement) => {
                    this._log.info("WidgetManager.setSuppressBorder()");
                    let widgetElement = containerElement.querySelector(WIDGET_CONTAINER_SELECTOR);
                    if (widgetElement) {
                        if (config.hasOwnProperty('SuppressBorder') && config.SuppressBorder === true) {
                            widgetElement.classList.add(NO_BORDER_CLASS);
                        }
                        else {
                            widgetElement.classList.remove(NO_BORDER_CLASS);
                        }
                    }
                };
                this.setSuppressHeading = (config, containerElement) => {
                    this._log.info("WidgetManager.setSuppressHeading()");
                    let headingElement = containerElement.querySelector(WIDGET_HEADING_SELECTOR);
                    if (headingElement) {
                        if (config.hasOwnProperty('SuppressHeading') && config.SuppressHeading === true) {
                            headingElement.classList.add(NO_HEADER_CLASS);
                        }
                        else {
                            headingElement.classList.remove(NO_HEADER_CLASS);
                        }
                    }
                };
                this.setWidgetHeight = (config, containerElement, sizeProperty = "Size") => {
                    this._log.info("WidgetManager.setWidgetHeight()");
                    let resizableElement = containerElement.querySelector(WIDGET_SIZE_SELECTOR);
                    if (resizableElement) {
                        resizableElement.classList.remove(HEIGHT_CLASS, HEIGHT_CLASS_FULL, HEIGHT_CLASS_HALF, HEIGHT_CLASS_QUARTER);
                        if (config.hasOwnProperty(sizeProperty) && config[sizeProperty].length > 0) {
                            let size = config[sizeProperty];
                            let sizeClass = HEIGHT_CLASS_HALF;
                            if (size === 'Full') {
                                sizeClass = HEIGHT_CLASS_FULL;
                            }
                            else if (size === 'Quarter') {
                                sizeClass = HEIGHT_CLASS_QUARTER;
                            }
                            if (this._log.isTraceEnabled()) {
                                this._log.trace("setting widget height class to: " + sizeClass);
                            }
                            resizableElement.classList.add(HEIGHT_CLASS, sizeClass);
                        }
                    }
                };
                this.createStandaloneWidget = (widgetName, layout, widgetConfig, readyCallback = null) => __awaiter(this, void 0, void 0, function* () {
                    this._log.info("WidgetManager.createStandaloneWidget()");
                    if (this._log.isTraceEnabled()) {
                        this._log.trace("looking at widget: " + widgetName);
                    }
                    let widgetMapping = STANDARD_WIDGETS.find(widget => widget.Name === widgetName);
                    if (widgetMapping != undefined) {
                        if (this._log.isTraceEnabled()) {
                            this._log.trace("found standard widget '" + widgetMapping.Name + "' with class: " + widgetMapping.Class);
                        }
                        if (!widgetConfig.hasOwnProperty('Disabled') || !widgetConfig.Disabled) {
                            if (this._log.isTraceEnabled()) {
                                this._log.trace("widget '" + widgetName + "' is active");
                            }
                            try {
                                let widgetConstructor = this._core.Functions.stringToFunction(widgetMapping.Class);
                                let widget = new widgetConstructor(this._core, this, widgetName, widgetConfig, layout, readyCallback);
                                widget.createInstances();
                                if (this._log.isTraceEnabled()) {
                                    this._log.trace("return standard widget");
                                }
                                return widget;
                            }
                            catch (ex) {
                                console.warn("failed to create widget '" + widgetName + "' - " + ex.message);
                            }
                        }
                        else {
                            if (this._log.isTraceEnabled()) {
                                this._log.trace("widget '" + widgetName + "' is not active");
                            }
                        }
                    }
                    else {
                        if (this._log.isTraceEnabled()) {
                            this._log.trace("assuming custom widget, because no mapping found for widget name: " + widgetName);
                        }
                        // Massive load of conditions to allow creation
                        let appConfig = this._core.Config.getApplicationConfig();
                        let allowCustom = (appConfig.hasOwnProperty('Custom') && appConfig.Custom.hasOwnProperty('UseCustomObjects') && !appConfig.Custom.UseCustomObjects) ? false : true;
                        if (!allowCustom) {
                            console.warn("failed to create widget '" + widgetName + "' - custom widgets not allowed");
                        }
                        else if (!(widgetConfig.hasOwnProperty('CustomWidgetFile') && widgetConfig.hasOwnProperty('CustomWidgetClass'))) {
                            console.warn("failed to create widget '" + widgetName + "' - missing custom widget properties");
                        }
                        else if (!widgetConfig.hasOwnProperty('Disabled') || !widgetConfig.Disabled) {
                            if (this._log.isTraceEnabled()) {
                                this._log.trace("custom widget '" + widgetName + "' is active");
                                this._log.trace("using JS file: " + widgetConfig.CustomWidgetFile);
                                this._log.trace("using class: " + widgetConfig.CustomWidgetClass);
                            }
                            let wm = this;
                            let promiseFn = function (resolve, reject) {
                                return __awaiter(this, void 0, void 0, function* () {
                                    let widget = null;
                                    let createWidgetFn = function () {
                                        if (this._log.isTraceEnabled()) {
                                            this._log.trace("create widget function");
                                        }
                                        widget = wm._createStandaloneCustomWidget(widgetName, widgetConfig, layout, readyCallback);
                                    };
                                    if (this._log.isTraceEnabled()) {
                                        this._log.trace("loading JS file and calling create widget function on load");
                                    }
                                    wm._core.Loader.loadUnversionedJS(widgetConfig.CustomWidgetFile, createWidgetFn, wm._customWidgetLoadFailed.bind(wm, widgetName));
                                    let counter = 0;
                                    while (widget == null && counter < WPTNamespace.MAX_SLEEP_INTERVALLS) {
                                        counter++;
                                        yield wm._core.Functions.sleep(wm._core.getSleepTime());
                                    }
                                    if (counter >= WPTNamespace.MAX_SLEEP_INTERVALLS) {
                                        let msg = "no standalone custom widget created during " + WPTNamespace.MAX_SLEEP_INTERVALLS + " intervals of waiting, hence aborted...";
                                        console.warn(msg);
                                        reject(msg);
                                    }
                                    else {
                                        if (this._log.isTraceEnabled()) {
                                            this._log.trace("finished waiting for standalone custom widget created: " + counter);
                                        }
                                        resolve(widget);
                                    }
                                });
                            };
                            let result = new Promise(promiseFn);
                            if (this._log.isTraceEnabled()) {
                                this._log.trace("returning promise");
                            }
                            return result;
                        }
                        else {
                            if (this._log.isTraceEnabled()) {
                                this._log.trace("custom widget '" + widgetName + "' is not active");
                            }
                        }
                    }
                });
                this._displayStandardWidgets = () => {
                    this._log.info("WidgetManager._displayStandardWidgets()");
                    let appConfig = this._core.Config.getApplicationConfig();
                    if (appConfig.hasOwnProperty('Layout') && appConfig.Layout.hasOwnProperty('Widgets')) {
                        for (let widgetName in appConfig.Layout.Widgets) {
                            if (this._log.isTraceEnabled()) {
                                this._log.trace("looking at widget: " + widgetName);
                            }
                            let widgetMapping = STANDARD_WIDGETS.find(widget => widget.Name === widgetName);
                            if (widgetMapping != undefined) {
                                if (this._log.isTraceEnabled()) {
                                    this._log.trace("found widget '" + widgetMapping.Name + "' with class: " + widgetMapping.Class);
                                }
                                let widgetConfig = appConfig.Layout.Widgets[widgetName];
                                if (!widgetConfig.hasOwnProperty('Disabled') || !widgetConfig.Disabled) {
                                    if (this._log.isTraceEnabled()) {
                                        this._log.trace("widget '" + widgetName + "' is active");
                                    }
                                    try {
                                        let widgetConstructor = this._core.Functions.stringToFunction(widgetMapping.Class);
                                        let widget = new widgetConstructor(this._core, this, widgetName, widgetConfig, WPTNamespace.Navigation.HOME_VIEW_NAME);
                                        this.StandardTypes[widgetName] = widget;
                                        this.StandardTypes.push(widget);
                                        widget.createInstances();
                                        this.StandardInstances.push(...widget.Instances);
                                        let instancesLength = widget.Instances.length;
                                        for (let i = 0; i < instancesLength; i++) {
                                            let instance = widget.Instances[i];
                                            this.StandardInstances[instance.getId()] = instance;
                                        }
                                    }
                                    catch (ex) {
                                        console.warn("failed to create widget '" + widgetName + "' - " + ex.message);
                                    }
                                }
                                else {
                                    if (this._log.isTraceEnabled()) {
                                        this._log.trace("widget '" + widgetName + "' is not active");
                                    }
                                }
                            }
                            else {
                                console.warn("no mapping for widget name: " + widgetName);
                            }
                        }
                    }
                    else {
                        console.warn("no standard widgets configured in application");
                    }
                };
                this._displayCustomWidgets = () => {
                    this._log.info("WidgetManager._displayCustomWidgets()");
                    let appConfig = this._core.Config.getApplicationConfig();
                    if (appConfig.hasOwnProperty('Custom') && (!appConfig.Custom.hasOwnProperty('UseCustomObjects') || appConfig.Custom.UseCustomObjects) && appConfig.Custom.hasOwnProperty('CustomWidgets')) {
                        for (let widgetName in appConfig.Custom.CustomWidgets) {
                            if (this._log.isTraceEnabled()) {
                                this._log.trace("looking at custom widget: " + widgetName);
                            }
                            let widgetConfig = appConfig.Custom.CustomWidgets[widgetName];
                            if (widgetConfig.hasOwnProperty('CustomWidgetFile') && widgetConfig.hasOwnProperty('CustomWidgetClass') && (!widgetConfig.hasOwnProperty('Disabled') || !widgetConfig.Disabled)) {
                                if (this._log.isTraceEnabled()) {
                                    this._log.trace("custom widget '" + widgetName + "' is active");
                                    this._log.trace("using JS file: " + widgetConfig.CustomWidgetFile);
                                    this._log.trace("using class: " + widgetConfig.CustomWidgetClass);
                                }
                                this._core.Loader.loadUnversionedJS(widgetConfig.CustomWidgetFile, this._createCustomWidget.bind(this, widgetName, widgetConfig, WPTNamespace.Navigation.HOME_VIEW_NAME), this._customWidgetLoadFailed.bind(this, widgetName));
                            }
                            else {
                                if (this._log.isTraceEnabled()) {
                                    this._log.trace("custom widget '" + widgetName + "' is not active");
                                }
                            }
                        }
                    }
                };
                this._createCustomWidget = (widgetName, widgetConfig, layout) => {
                    this._log.info("WidgetManager._createCustomWidget()");
                    try {
                        let widgetConstructor = this._core.Functions.stringToFunction(widgetConfig.CustomWidgetClass);
                        let widget = new widgetConstructor(this._core, this, widgetName, widgetConfig, layout);
                        this.CustomTypes[widgetName] = widget;
                        this.CustomTypes.push(widget);
                        widget.createInstances();
                        this.CustomInstances.push(...widget.Instances);
                        let instancesLength = widget.Instances.length;
                        for (let i = 0; i < instancesLength; i++) {
                            let instance = widget.Instances[i];
                            this.CustomInstances[instance.getId()] = instance;
                        }
                    }
                    catch (ex) {
                        console.warn("failed to create custom widget '" + widgetName + "' - " + ex.message);
                    }
                };
                this._createStandaloneCustomWidget = (widgetName, widgetConfig, layout, readyCallback = null) => {
                    this._log.info("WidgetManager._createStandaloneCustomWidget()");
                    try {
                        let widgetConstructor = this._core.Functions.stringToFunction(widgetConfig.CustomWidgetClass);
                        let widget = new widgetConstructor(this._core, this, widgetName, widgetConfig, layout, readyCallback);
                        widget.createInstances();
                        return widget;
                    }
                    catch (ex) {
                        console.warn("failed to create standalone custom widget '" + widgetName + "' - " + ex.message);
                    }
                };
                // Only finds instances created for the Home layout, otherwise ask the layout
                // There is no index, so this will be slow, but there should only be ~10 instances max to loop through
                this.getInstanceByHandle = (handle) => {
                    this._log.info("WidgetManager.getInstanceByHandle()");
                    let result = this.StandardInstances.find(instance => instance.Handle == handle);
                    if (!result)
                        result = this.CustomInstances.find(instance => instance.Handle == handle);
                    if (!result)
                        return null;
                    else
                        return result;
                };
                this.getInstanceById = (id) => {
                    this._log.info("WidgetManager.getInstanceById()");
                    let result = this.StandardInstances.find(instance => instance.Id == id);
                    if (!result)
                        result = this.CustomInstances.find(instance => instance.Id == id);
                    if (!result)
                        return null;
                    else
                        return result;
                };
                this._customWidgetLoadFailed = (widgetName, path, message) => {
                    this._log.info("WidgetManager._customWidgetLoadFailed()");
                    console.warn("failed to load custom widget '" + widgetName + "': " + path);
                    let msgPrefix = this._core.Locale.getTranslation('STR_WPT_CUSTOMWIDGET_ERROR_MSG');
                    let errorMsg = msgPrefix + ": " + widgetName + " (" + path + ").";
                    if (message !== undefined && message.length > 0) {
                        errorMsg += " " + this._core.Locale.getTranslation("STR_WPT_ERROR") + ": " + message;
                    }
                    this._core.Helper.presentWarningModal(errorMsg);
                };
                this._setWidgetTitle = (headerElement, title) => {
                    this._log.info("WidgetManager._setWidgetTitle()");
                    if (this._useWidgetIcon) {
                        if (this._log.isTraceEnabled()) {
                            this._log.trace("using widget icon");
                        }
                        let titleIcon = headerElement.querySelector('.' + WIDGET_TITLEICON_CLASS);
                        let titleElement = headerElement.querySelector('.' + WIDGET_TITLE_CLASS);
                        if (this._log.isTraceEnabled()) {
                            this._log.trace("performed checks");
                        }
                        if (titleIcon && titleElement) {
                            if (this._log.isTraceEnabled()) {
                                this._log.trace("icon already added");
                            }
                            if (title != null) {
                                this._core.Helper.setElementTranslation(titleElement, title);
                                this._core.Helper.setElementTranslationAttribute(titleElement, 'title', title);
                            }
                        }
                        else {
                            let oldTitle = headerElement.innerHTML;
                            if (this._log.isTraceEnabled()) {
                                this._log.trace("creating icon");
                            }
                            headerElement.innerHTML = '';
                            titleIcon = document.createElement('span');
                            headerElement.appendChild(titleIcon);
                            titleIcon.classList.add(WIDGET_TITLEICON_CLASS);
                            titleElement = document.createElement('span');
                            headerElement.appendChild(titleElement);
                            titleElement.classList.add(WIDGET_TITLE_CLASS);
                            if (title != null) {
                                this._core.Helper.setElementTranslation(titleElement, title);
                                this._core.Helper.setElementTranslationAttribute(titleElement, 'title', title);
                            }
                            else {
                                titleElement.innerHTML = oldTitle;
                            }
                        }
                    }
                    else {
                        if (this._log.isTraceEnabled()) {
                            this._log.trace("no widget icon");
                        }
                        if (title != null) {
                            this._core.Helper.setElementTranslation(headerElement, title);
                            this._core.Helper.setElementTranslationAttribute(headerElement, 'title', title);
                        }
                    }
                };
                this.setWidgetCollapseStateDirect = (instance, expanded) => {
                    this._log.info("WidgetManager.setWidgetCollapseStateDirect()");
                    let collapsePanel = $(`#${instance.Container.id} ${WIDGET_PANEL_SELECTOR}`);
                    if (expanded)
                        this._expandWidget(instance.Container, collapsePanel);
                    else
                        this._collapseWidget(instance.Container, collapsePanel);
                };
                this._expandWidget = (container, jqElement) => {
                    this._log.info("WidgetManager._expandWidget()");
                    jqElement.collapse('show');
                    if (this._useWidgetIcon) {
                        if (this._log.isTraceEnabled()) {
                            this._log.trace("using widget icon");
                        }
                        let titleIcon = container.querySelector('.' + WIDGET_TITLEICON_CLASS);
                        if (titleIcon) {
                            titleIcon.classList.remove(...this._iconCollapsed);
                            titleIcon.classList.add(...this._iconExpanded);
                        }
                    }
                };
                this._collapseWidget = (container, jqElement) => {
                    this._log.info("WidgetManager._collapseWidget()");
                    jqElement.collapse('hide');
                    if (this._useWidgetIcon) {
                        let titleIcon = container.querySelector('.' + WIDGET_TITLEICON_CLASS);
                        if (titleIcon) {
                            titleIcon.classList.remove(...this._iconExpanded);
                            titleIcon.classList.add(...this._iconCollapsed);
                        }
                    }
                };
                this._toggleWidgetCollapseState = (instance, jqElement) => {
                    this._log.info("WidgetManager._toggleWidgetCollapseState()");
                    if (jqElement.hasClass("in")) {
                        this._collapseWidget(instance.Container, jqElement);
                    }
                    else {
                        this._expandWidget(instance.Container, jqElement);
                    }
                };
                this._core = core;
                this._log = this._core.Logging.getLogger(LOG_CATEGORY);
                this._log.info("WidgetManager::constructor");
                this.Cache = new WidgetCache(core);
                this._useWidgetIcon = true;
                this._iconCollapsed = DEFAULT_ICON_COLLAPSED.split(" ");
                this._iconExpanded = DEFAULT_ICON_EXPANDED.split(" ");
                let appConfig = core.Config.getApplicationConfig();
                if (appConfig.hasOwnProperty('Layout') && appConfig.Layout != null) {
                    if (appConfig.Layout.hasOwnProperty('DisableWidgetIcon') && appConfig.Layout.DisableWidgetIcon === true) {
                        if (this._log.isTraceEnabled()) {
                            this._log.trace("disabling widget icon");
                        }
                        this._useWidgetIcon = false;
                    }
                    else {
                        if (appConfig.Layout.hasOwnProperty('WidgetIconCollapsed') && appConfig.Layout.WidgetIconCollapsed != null && appConfig.Layout.WidgetIconCollapsed.length > 0) {
                            this._iconCollapsed = appConfig.Layout.WidgetIconCollapsed.split(" ");
                        }
                        if (appConfig.Layout.hasOwnProperty('WidgetIconExpanded') && appConfig.Layout.WidgetIconExpanded != null && appConfig.Layout.WidgetIconExpanded.length > 0) {
                            this._iconExpanded = appConfig.Layout.WidgetIconExpanded.split(" ");
                        }
                    }
                }
            }
        }
        Widgets.WidgetManager = WidgetManager;
    })(Widgets = WPTNamespace.Widgets || (WPTNamespace.Widgets = {}));
})(WPTNamespace || (WPTNamespace = {}));
